import EA from 'helpers/init';

export default EA.Methods.mobileNav = ($this) => {
    $this.addEventListener('click', () => {
        document.body.classList.toggle('menu-open');
    });
};
